import type { ColumnDef, Row } from "@tanstack/react-table"

/** Exact match for connection_type select filters. */
export function exactStringFilterFn<T>(
  row: Row<T>,
  columnId: string,
  filterValue: unknown,
): boolean {
  const needle = String(filterValue ?? "").trim().toLowerCase()
  if (!needle) return true
  return String(row.getValue(columnId) ?? "").trim().toLowerCase() === needle
}

/** Match a single plan inside a comma-separated service_plan cell. */
export function commaSeparatedIncludesFilterFn<T>(
  row: Row<T>,
  columnId: string,
  filterValue: unknown,
): boolean {
  const needle = String(filterValue ?? "").trim().toLowerCase()
  if (!needle) return true
  return String(row.getValue(columnId) ?? "")
    .split(",")
    .map((p) => p.trim().toLowerCase())
    .filter(Boolean)
    .includes(needle)
}

/** Columns used only for filtering can be marked meta.hidden. */
export function buildHiddenColumnVisibility(
  columns: ColumnDef<any, any>[],
): Record<string, boolean> {
  const visibility: Record<string, boolean> = {}
  columns.forEach((column) => {
    const meta = (column as ColumnDef<any> & { meta?: { hidden?: boolean } }).meta
    if (!meta?.hidden) return
    const id =
      ("id" in column && typeof column.id === "string" && column.id) ||
      (typeof column.accessorKey === "string" ? column.accessorKey : null)
    if (id) visibility[id] = false
  })
  return visibility
}
